import {slideDown, slideUp} from '@siteparts/show-hide-effects';
import docCookies from 'cookies.js';
import {Dialog} from './webmodel/dialog.js';

var notifyDialog;

function openLoginDialog()
{
	window.location.href = document.getElementById('cnc-toolbar-login-button').href;
}

function init()
{
	var menus = [{
		container: '#cnc-toolbar-apps',
		button:    '#cnc-toolbar-apps-button'
	}, {
		container: '#cnc-toolbar-settings',
		button:    '#cnc-toolbar-settings-button'
	}];

	var h = 'cnc-toolbar-hidden';
	var i;

	for (i in menus) {
		document.querySelector(menus[i].container).classList.add(h);
	}

	document.addEventListener('click', function (event) {
		var i;
		var buttonIndex = -1;
		var t = event.target;

		for (i in menus) {
			// Click on popup menu button
			if (t.closest(menus[i].button) !== null) {
				buttonIndex = i;
				event.preventDefault();
			}
		}

		// This has to be after detecting a button click, otherwise we return too soon
		if (buttonIndex == -1) {
			for (i in menus) {
				// Don't respond on click within container
				if (t.closest(menus[i].container) !== null) {
					return;
				}
			}
		}

		for (i in menus) {
			var c = document.querySelector(menus[i].container);
			if (buttonIndex != i) {
				// Close all popup menus except for one to be opened
				if (!c.classList.contains(h)) {
					c.classList.add(h);
				}
			} else {
				// Open popup menu if closed and clicked on a button
				c.classList.toggle(h);

				if (menus[i].container == '#cnc-toolbar-apps') {
					c.style.left = (document.querySelector(menus[i].button).offsetLeft - 18) + "px";
				}
			}
		}
	});

	// Notify dialog
	initEuCookiesNotification();

	initNotifyDialog();

	initBiblioNotification();

	initPinned();
}

function pinApp(appName)
{
	let li = document.querySelector('#cnc-toolbar-apps li[data-app-name='+appName+']');

	let following = [];
	let nextLi = li.nextElementSibling;

	while (nextLi != null) {
		following.push(nextLi.dataset.appName);
		nextLi = nextLi.nextElementSibling;
	}

	let newLi = document.createElement("li");
	newLi.appendChild(li.querySelector("a").cloneNode(true));
	newLi.dataset.appName = appName;

	let pinnedUl = document.querySelector('#cnc-toolbar-pinned ul');
	let pinnedLi = pinnedUl.firstElementChild;

	while (pinnedLi != null) {
		if (following.includes(pinnedLi.dataset.appName)) {
			break;
		}

		pinnedLi = pinnedLi.nextElementSibling;
	}

	pinnedUl.insertBefore(newLi, pinnedLi);
}

function unpinApp(appName)
{
	let li = document.querySelector('#cnc-toolbar-pinned li[data-app-name='+appName+']');

	if (li != null) {
		li.remove();
	}
}

function initPinned()
{
	let appsDiv = document.querySelector('#cnc-toolbar-apps');
	let pinnedDiv = document.querySelector('#cnc-toolbar-pinned');
	let pinnedUl = pinnedDiv.querySelector('ul');

	if (pinnedUl.children.length == 0) {
		pinnedDiv.style.display = "none";
	}

	if (appsDiv.dataset.pinnable != "true") {
		return;
	}

	let starSvg = document.querySelector('#cnc-toolbar-star-svg').content.firstElementChild;

	appsDiv.querySelectorAll('li').forEach(li => {
		// Add pin/unpin button
		let span = document.createElement("span");
		span.classList.add('cnc-toolbar-pin-button');
		span.appendChild(starSvg.cloneNode(true));
		li.insertBefore(span, li.firstElementChild);

		span.addEventListener("click", () => {
			let appName = li.dataset.appName;

			li.classList.toggle('cnc-toolbar-pinned-app');

			if (li.classList.contains('cnc-toolbar-pinned-app')) {
				pinApp(appName);
			} else {
				unpinApp(appName);
			}

			// Submit pinned names
			let names = [];
			let pinnedLi = pinnedUl.firstElementChild;

			while (pinnedLi != null) {
				names.push(pinnedLi.dataset.appName);
				pinnedLi = pinnedLi.nextElementSibling;
			}

			fetch(pinnedDiv.dataset.submitUrl, {
				method: "POST",
				credentials: "include",
				body: JSON.stringify({names: names})
			})
			.then(response => response.json())
			.then(data => {});

			// Show/hide pinned apps
			if (pinnedUl.children.length > 0) {
				pinnedDiv.style.removeProperty("display");
			} else {
				pinnedDiv.style.display = "none";
			}
		});
	});
}

function initNotifyDialog()
{
	var notifyDiv = document.getElementById('cnc-toolbar-notifications');
	var notifyList = notifyDiv.firstElementChild;
	var modalCount = 0;

	notifyDialog = new Dialog(notifyDiv, 'cnc-toolbar-dialog-window');

	notifyDialog.addNotification = function (element, autoOpen) {
		autoOpen = typeof autoOpen !== 'undefined' ? autoOpen : true;
		element.style.display = "none";
		notifyList.appendChild(element);
		slideDown(element);

		if (autoOpen) {
			notifyDialog.open();
		}

		if (element.dataset.isModal == "true") {
			modalCount++;
		}

		notifyDialog.setModal(modalCount > 0);
	};

	notifyDialog.removeNotification = function (element) {
		// Remove only if element is child of notifyList
		if (element.parentNode == notifyList) {
			if (element.dataset.isModal == "true") {
				modalCount--;
			}

			notifyDialog.setModal(modalCount > 0);

			// Close dialog if removing last notification
			if (notifyList.children.length == 1) {
				notifyDialog.close();
			}

			slideUp(element, {complete: function () {
				element.parentNode.removeChild(element);
			}});
		}
	};

	// Check for modality
	Array.prototype.forEach.call(notifyList.children, function (element) {
		if (element.dataset.isModal == "true") {
			modalCount++;
		}
	});
	notifyDialog.setModal(modalCount > 0);

	// Open if not empty
	if (notifyList.children.length > 0) {
		notifyDialog.open();
	}

	// Hide button
	var hideButton = notifyDiv.lastElementChild;
	hideButton.style.display = "";
	hideButton.addEventListener('click', function (e) {
		e.preventDefault();
		notifyDialog.close();
	});
}

function initBiblioNotification()
{
	var div = document.getElementById('cnc-toolbar-notification-biblio');
	if (div !== null) {
		var button = div.querySelector('button');
		button.addEventListener('click', function () {
			notifyDialog.removeNotification(div);
		});
	}
}

function initEuCookiesNotification()
{
	var div = document.getElementById('cnc-toolbar-notification-eu-cookies');
	if (div !== null) {
		var cookieKey = div.dataset.cookieKey;

		if (docCookies.hasItem(cookieKey)) {
			docCookies.removeItem(cookieKey, "/", div.dataset.cookieDomain);
		}

		div.parentNode.removeChild(div);
	}
}

function notificationDialog()
{
	return notifyDialog;
}

function setContinueUrl(url)
{
	[
		document.getElementById('cnc-toolbar-login-button'),
		document.getElementById('cnc-toolbar-user-button'),
		document.getElementById('cnc-toolbar-lang'),
	].forEach(element => {
		if (element !== null) {
			let u = new URL(element.href);
			u.searchParams.set("continue", url);
			element.href = u.toString();
		}
	});
}

export {
	notificationDialog,
	openLoginDialog,
	setContinueUrl,
	init
};
